export { YOUTUBE_URL } from '@fmpedia/validators'

export const FM_YOUTUBE_URL =
  'https://www.youtube.com/@FinanceMagnates_official'
